declare global {
  interface Window {
    __MEEGO_EXTERNALS__: Record<string, any>;
  }
}
window.__MEEGO_EXTERNALS__ = window.__MEEGO_EXTERNALS__ || {};

const globalMeegoExternals = window.__MEEGO_EXTERNALS__;

export { globalMeegoExternals };
